import React from 'react'

import { Icon } from 'antd'
import { TooltipProps } from 'antd/lib/tooltip'
import { IconProps } from 'antd/lib/icon'

import { Tooltip } from '..'

function ToolIcon({
  title,
  ...props
}: Pick<TooltipProps, 'title'> & IconProps) {
  return (
    <Tooltip title={title}>
      <Icon {...props} />
    </Tooltip>
  )
}

export { ToolIcon }
